export const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '48%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '100%',
  maxHeight: '100%',
  width: 600,
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: 2,
  outline: 'none',
  boxShadow: 24,
  overflowY: 'scroll',
  scrollbarWidth: 'none',
  pt: 2,
  px: 4,
  pb: 3,
};
